export const title = "Keress bizalommal!";
export const desc = (
  <>
    Amennyiben szeretnél részletes tájékoztatót kapni vagy időpontot
    egyeztetnél, vedd fel velem a kapcsolatot e-mailben vagy telefonon!
  </>
);
export const link = "Elérhetőségek";
